import { render, staticRenderFns } from "./indexCategoryManager.vue?vue&type=template&id=6618db9b&"
import script from "./indexCategoryManager.vue?vue&type=script&lang=js&"
export * from "./indexCategoryManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports